export default defineNuxtPlugin((nuxtApp) => {
  const isEnabled = nuxtApp.$config.public.debugTestId
  nuxtApp.vueApp.directive(
    'testid',
    isEnabled
      ? {
          mounted(el, binding) {
            el.setAttribute('data-testid', binding.value)
          },
          updated(el, binding) {
            el.setAttribute('data-testid', binding.value)
          },
        }
      : {},
  )
})
